import {
    collection,
    doc,
    type FirestoreDataConverter,
    getDoc,
    QueryDocumentSnapshot,
    type SnapshotOptions,
} from "firebase/firestore";
import { Timestamp } from "firebase/firestore";

import { db } from "@/lib/firebase/client.ts";
import type { News } from "@/models/news.ts";
import { DatabaseRepository } from "@/repositories/database-repository.ts";

const newsConverter: FirestoreDataConverter<News> = {
    toFirestore(session: News) {
        return { ...session };
    },
    fromFirestore(snapshot: QueryDocumentSnapshot, options: SnapshotOptions): News {
        const data = snapshot.data(options)!;
        return {
            uid: snapshot.id, // always safe
            ...data,
            createdAt: (data.createdAt as Timestamp)?.toDate(),
            updatedAt: (data.updatedAt as Timestamp)?.toDate(),
        } as News;
    },
};

export class NewsRepository extends DatabaseRepository<News> {
    private static instance: NewsRepository;
    protected readonly collection = collection(db, "news").withConverter(newsConverter);

    private constructor() {
        super();
    }

    public static getInstance(): NewsRepository {
        if (!NewsRepository.instance) {
            NewsRepository.instance = new NewsRepository();
        }
        return NewsRepository.instance;
    }

    async getById(uid: string): Promise<News | null> {
        const ref = doc(this.collection, uid);
        const snap = await getDoc(ref);
        if (!snap.exists()) return null;
        return snap.data() satisfies News;
    }
}
